import React from 'react'
import { useParams } from 'react-router-dom'

import { ActivityTabContent } from '../components/certificateTabs/tabs/ActivityTabContent'
import { CertificateSubView } from './CertificateSubView'

/**
 * VERA-315 Phase 4 — the Activity tab, as its own screen.
 *
 * Footer sticks: this is a paging timeline, so the attribution would otherwise
 * sit somewhere far below whatever has loaded so far.
 */
export const ActivitySubView = () => {
  const { certificateId } = useParams()

  return (
    <CertificateSubView title='Activity' footerSticky>
      {() => <ActivityTabContent certificateId={certificateId || ''} />}
    </CertificateSubView>
  )
}
